import React from "react";
import isEmpty from "lodash/isEmpty";
import { fundraiserGroupParser } from "@services";
import { Box } from "@atoms";
import { MemberList } from "../MemberList";
import { GroupSubHeader } from "../GroupSubHeader";
import { NoMemberSubGroupHeader } from "../NoMemberSubGroupHeader";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  fundraisers: $FixMe;
  isViewerOwner: boolean;
  isGroups: boolean;
  groups: $FixMe;
  groupedFundraisers: $FixMe;
  refetch: () => void;
  activeReassignmentMemberId: string | null;
  setActiveReassignmentMemberId: (value: string | null) => void;
}

// == Constants ============================================================

MemberListGrouped.defaultProps = {};

// == Functions ============================================================

const emptyPendingGroupChecker = (pendingMembers) => {
  const [{ fundraisers }] = pendingMembers;
  return fundraisers.length > 0 ? pendingMembers : [];
};

const groupFundraisersChecker = (group) => {
  const {
    paginatedFundraisers: { edges },
  } = group;
  return edges.filter((fundraiser) => !fundraiser.deactivatedAt).length > 0;
};

const groupsArrayMaker = (fundraisers, groups) => {
  const groupsArray = Object.values(fundraiserGroupParser(fundraisers, groups));
  const pendingMembers = emptyPendingGroupChecker(
    groupsArray.filter((group) => group.id === "__pending__")
  );
  const noGroup = groupsArray.filter((group) => group.id === "__noGroup__");
  const emptyFundraisersGroups = groupsArray.filter((group) => isEmpty(group.fundraisers));
  const groupsWithAmountRaisedSorted = groupsArray
    .filter((group) => group.amountRaised)
    .sort((a, b) => b.amountRaised.dollarsAmount - a.amountRaised.dollarsAmount);
  const filteredArray = groupsWithAmountRaisedSorted
    .filter((group) => group.id !== "__pending__")
    .filter((group) => group.id !== "__noGroup__");

  return [...filteredArray, ...emptyFundraisersGroups, ...noGroup];
};

// == Component ============================================================

export default function MemberListGrouped({
  fundraisers,
  isViewerOwner,
  isGroups,
  groups,
  groupedFundraisers,
  refetch,
  setActiveReassignmentMemberId,
  activeReassignmentMemberId,
}: IProps) {
  return groupedFundraisers.map((group) => (
    <Box key={group.id}>
      {groupFundraisersChecker(group) ? (
        <GroupSubHeader id={group.id} name={group.name} />
      ) : (
        <NoMemberSubGroupHeader id={group.id} name={group.name} />
      )}
      <MemberList
        activeReassignmentMemberId={activeReassignmentMemberId}
        fundraisers={group.paginatedFundraisers.edges}
        groupedFundraisers={groupedFundraisers}
        isGroups={isGroups}
        isViewerOwner={isViewerOwner}
        refetch={refetch}
        setActiveReassignmentMemberId={setActiveReassignmentMemberId}
      />
    </Box>
  ));
}

// == Styles ===============================================================
